export var ContentType;
(function (ContentType) {
    ContentType["CHART"] = "chart";
    ContentType["DASHBOARD"] = "dashboard";
    ContentType["SPACE"] = "space";
    ContentType["DATA_APP"] = "data_app";
})(ContentType || (ContentType = {}));
export var ContentSortByColumns;
(function (ContentSortByColumns) {
    ContentSortByColumns["NAME"] = "name";
    ContentSortByColumns["SPACE_NAME"] = "space_name";
    ContentSortByColumns["LAST_UPDATED_AT"] = "last_updated_at";
    ContentSortByColumns["VIEWS"] = "views";
})(ContentSortByColumns || (ContentSortByColumns = {}));
// Chart types
export var ChartSourceType;
(function (ChartSourceType) {
    ChartSourceType["DBT_EXPLORE"] = "dbt_explore";
    ChartSourceType["SQL"] = "sql";
})(ChartSourceType || (ChartSourceType = {}));
//# sourceMappingURL=content.js.map